const DefiningCraftSection = () => {
  return (
    <>
      {/* New Section: Defining Our Craft */}
      <section
        className="w-full px-6 md:px-32"
        style={{
          backgroundColor: '#efefef',
          paddingTop: '16px',
          paddingBottom: '16px',
          textAlign: 'center'
        }}
      >
        <h2
          style={{
            fontFamily: 'Cardo, serif',
            fontSize: '32px',
            color: '#764F2B',
            fontWeight: '400',
            marginBottom: '16px'
          }}
        >
          Defining Our Craft
        </h2>

        <p
          style={{
            fontFamily: 'Cardo, serif',
            fontSize: '16px',
            color: '#000000',
            lineHeight: '1.6',
            maxWidth: '500px',
            margin: '0 auto'
          }}
        >
          We have refined our craft through years of dedicated experience and unwavering commitment to excellence.
        </p>
      </section>

      {/* Original Section */}
      <section
        className="w-full"
        style={{
          height: '500px',
          paddingLeft: '64px',
          paddingRight: '64px',
          backgroundImage: 'url("/Landing Page/Circle Like No Other/Middle.png")',
          backgroundSize: 'cover',
          backgroundPosition: 'center left',
          backgroundRepeat: 'no-repeat',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end'
        }}
      >
        <div className="w-full text-right">

          <p
            style={{
              fontFamily: 'Cardo, serif',
              fontSize: '16px',
              color: '#FFFFFF',
              lineHeight: '1.6',
              maxWidth: '800px',
              marginLeft: 'auto'
            }}
          >
            FGA Prestige is a premier lifestyle management group, dedicated to curating exceptional experiences and tailored solutions for our members. With a comprehensive suite of services designed to enrich and elevate everyday living.
          </p>
        </div>
      </section>
    </>
  )
}

export default DefiningCraftSection